export default __webpack_public_path__ + "static/media/curtains.0c2d0f43.png";